import Vue from 'vue';
import VueRouter from 'vue-router';
import routers from './router';
import title from 'common/title';
import {reload} from '@/config/global';
import store from './../store/index';
import {login} from 'server/login';
import {setStore, getStore, getQueryString} from 'config/global';

Vue.use(VueRouter);

const scrollBehavior = function (to, from, savedPosition) {
	// savedPosition 会在你使用浏览器前进或后退按钮时候生效
   // 这个跟你使用 router.go() 或 router.back() 效果一致
   // 这也是为什么我在 tab 栏结构中放入了一个 点击回退 的按钮
   if (savedPosition) {
		return savedPosition
	  } else {
		// 如果不是通过上述行为切换组件，就会让页面回到顶部
		return {x: 0, y: 0}
	}
}
const routes = [{
	path: '/',
	redirect: '/server'
}];
Object.values(routers).forEach(router => {
	routes.push(...router);
});
const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior
});



//路由前置守卫
router.beforeEach((to, from, next) => {
	/*if (process.env.NODE_ENV === 'development') {
	 console.log("進來了");
	 //setStore('token', '8AB720A1-DA95-DC53-1FE1-CDBFC541C340')
	 next()
	 }
	 else {*/
	let token = getStore('token');
	// alert(window.location.href.token);
	if (token) {
		next();
	} else {
		let tokenQuery = getQueryString(token);
		// let token = getStore('token')
		if (tokenQuery) {
			setStore('token', tokenQuery);
			next();
		} else {
			// 微信授权
			reload();
		}
	}
	//}
});

//路由后置守卫
router.afterEach((to, from) => {
	window.document.title = title[to.name];
});


export default router;
